import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAddNotification } from 'hooks/useAddNotification'
import { post } from 'utils/http'

export const useCustomerCreate = () => {
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const createCustomer = async (values: any) => {
    const payload = {
      name: values.name,
      website: values.website,
      referer: values.referer || 'management',
      gift_code: values.giftCode,
      plan: values.plan,
      billing_period: values.billingPeriod,
      trial_days: values.trialDays,
      payment_method: values.paymentMethod,
      country: values.country,
    }

    return post('/management/customers', payload)
  }

  return useMutation({
    mutationFn: createCustomer,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customers'] })

      addNotification('Customer created successfully', 'success')
    },
    onError: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customers'] })
      addNotification('Error while creating customer', 'error')
    },
  })
}
